<template>
  <div
    class="table-saved-filters f-column"
    style="min-height: 0"
  >
    <GwFilter
      v-if="!tcrud_trulySelectedItems.length"
      class="mt-2"
      :asRow="true"
      :hasControls="false"
      :hasClearBtn="false"
      :hasSaveBtn="false"
      filterUrlPrefix="ffss"
      filterConfigKey="savedSpots"
    />
    <TableDeleteBtns
      v-else
      @confirm="tcrud_singleDeleteSelectedItems"
      @close="tcrud_resetSelectedRows()"
    />

    <TableBody
      ref="tablebody"
      :items="tcrud_items"
      :loading="tcrud_loading"
      :error="tcrud_error"
      :isInfiniteDynamic="true"
      size="small"
      keyField="public_id"
      class="gw_table_small mt-2 w-100"
    >
      <template #no_data>
        <div
          class="alert-box b-grey ma-4"
          style="--clr-alert: var(--clr-grey-2)"
        >
          {{ $t('data_table.saved_spots_table.no_files') }}
          <span v-html="$t('data_table.saved_spots_table.save_spots')"></span>
        </div>
      </template>
      <template #head_before>
        <TableHead
          v-if="tcrud_items.length"
          :sortConf="tbl_sortConf"
          :thead="thead"
          @click="tbl_handleSort"
        >
          <template #th_before>
            <TableHeadCell
              :sortConf="tbl_sortConf"
              class="f-center gw_table_head_cell_sort_icon_visible"
              style="
                --max-width-th: 2.5rem;
                --min-width-th: 2.5rem;
                --inset-sort-icon: auto;
                --padding-sortable-th: 0;
              "
              :item="{ sortKey: 'ordering_position' }"
              @click="tbl_handleSort"
            >
              <template #sort_icon>
                <div
                  class="gw_table_head_cell_sort_icon mdi mdi-drag-vertical csst csst_nm pa-1"
                  style="font-size: 1rem"
                ></div>
              </template>
            </TableHeadCell>
            <TableHeadCell
              class="f-center"
              style="
                --max-width-th: 2.5rem;
                --min-width-th: 2.5rem;
                --padding-th: 0;
                --overflow-th: none;
                border-top-left-radius: 4px;
              "
            >
              <TableMainCheckbox
                style="font-size: 1rem"
                :indeterminate="tcrud_mainCheckboxValue === 'indeterminate'"
                :value="tcrud_mainCheckboxValue === 'all'"
                @click="tcrud_toggleSelectedAll"
              />
            </TableHeadCell>
          </template>
        </TableHead>
      </template>
      <template #default="{ item, index }">
        <SavedSpotsTableV1Row
          :thead="thead"
          :item="item"
          :index="index"
          tagType="saved_spots"
          :allTags="allTags"
          :mobile="mobile"
          :isSelected="!!tcrud_selectedItems[index]"
          :draggedItems="tcrud_draggedItems"
          :dragDisabled="tbl_sortConf.sortKey !== 'ordering_position'"
          :namespace
          @toggle:selected="tcrud_toggleSelected(item, index, tcrud_items)"
          @open:detail="
            detailItem = (detailItem ? detailItem.public_id : '') === item.public_id ? null : item
          "
          @click:tag_item="tag => tcrud_handleTagClick({ item, tag })"
          @drag:start="e => tcrud_handleDragstart({ e, item })"
        >
        </SavedSpotsTableV1Row>
        <SavedSpotsTableV1RowDetail
          v-if="detailItem ? detailItem.public_id === item.public_id : false"
          :item="item"
          @click.stop
          @patch:note="patchNote"
        />
      </template>
    </TableBody>

    <DragDropHandler
      ref="dragdrophandler"
      :getIndicatorStyle="tcrud_getDragIndicatorStyle"
      :proccessEvent="tcrud_scrollTable"
      dropTargetIdPart="saved-spots_table_row"
      @drag:drop="tcrud_handleDragdrop"
    >
      <template #shallowitem>
        <div
          class="gw_box"
          style="--clr-box-back: var(--clr-primary)"
        >
          <div
            v-if="tcrud_draggedItems.length > 1"
            class="truncate"
          >
            {{
              $t('common.xxx_selected_items', {
                num: tcrud_draggedItems.length,
              })
            }}
          </div>
          <GameformatOption
            v-else-if="tcrud_draggedItem"
            class="truncate"
            :customItem="getGameformat(tcrud_draggedItem)"
          />
        </div>
      </template>
    </DragDropHandler>
    <div class="f-center mt-1">
      <div
        class="gw_btn gw_btn_text text-medium weight_500 clr-grey mr-auto"
        @click="
          $store.dispatch(
            'router_set_dialogs',
            'table-columns-settings-dialog_table-savedspots_delete-disabled',
          )
        "
      >
        <div class="mdi mdi-pencil text-snormal mr-1"></div>
        {{ $t('btn.edit') }}
      </div>
    </div>
  </div>
</template>

<script>
import TableDeleteBtns from '@/components/DataTables/TableDeleteBtns'
import GameformatOption from '@/components/GameFormat/GameFormatOption'
import GwFilter from '@/components/DataTables/Filters/new/GwFilter'
import { allSitesOptions, namespaces } from '@/helpers/constants'
import { getGameformat } from '@/store/gameformat/gameformat'

import { getTagFilteredTableData } from '@/store/tableFilters/tableFilters'
import { defaultTablesColumns } from '@/store/userSettings/settingsDefaults'

import TableHead from '@/components/DataTables/v2/TableHead'
import TableHeadCell from '@/components/DataTables/v2/TableHeadCell'
import TableBody from '@/components/DataTables/v2/TableBody'
import SavedSpotsTableV1Row from '@/components/DataTables/v2/tables/SavedSpotsTableV1/SavedSpotsTableV1Row'
import DragDropHandler from '@/components/lib/DragDropHandler'
import SavedSpotsTableV1RowDetail from '@/components/DataTables/v2/tables/SavedSpotsTableV1/SavedSpotsTableV1RowDetail'

import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'
import tcrud_mix from '@/components/DataTables/tcrud_mix'

export default {
  name: 'SavedSpotsTableV1',
  components: {
    SavedSpotsTableV1RowDetail,
    TableHead,
    TableHeadCell,
    TableBody,
    SavedSpotsTableV1Row,
    DragDropHandler,
    TableDeleteBtns,
    GameformatOption,
    GwFilter,
  },
  mixins: [tcrud_mix, table_mix, float_mix],
  props: {
    namespace: { type: String, required: true },
  },
  data() {
    this.sitesOptions = allSitesOptions()
    this.tcrud_conf = {
      getEndpoint: item => `poker/saved-spots/${item.public_id}/`,
      getDeleteEndpoint: item => `poker/saved-spots/${item.public_id}/`,
      deleteSuccessMessage: 'messages.sucess_deleting_spots',
      deleteErrorMessage: 'messages.error_deleting_spots',
      idKey: 'public_id',
    }

    this.tbl_persistSortKey = 'savedspots_sort'
    this.tcrud_endpoint = 'poker/saved-spots/'
    this.tcrud_mutation = 'api_poker_saved_spots_table'
    this.tcrud_apiVersion = 'v1'
    return {
      tbl_sortConf: {
        sortKey: 'ordering_position',
        sortOrder: 'desc',
      },
      // selectedRows: [],
      // lastTouchedIdx: -1,
      detailItem: null,

      tcrud_limit: 9999,
      tcrud_offset: 0,
    }
  },
  created() {
    this.tbl_setSortConf()
    this.tcrud_getDataCheck()
  },
  methods: {
    patchNote({ item, note }) {
      if (note.length > 500) return
      const expected_item = {
        ...item,
        note: note.trim(),
      }
      this.tcrud_patchItem({
        item,
        patchData: { note: note.trim() },
        expected_item,
      })
      this.detailItem = null
    },
    getGameformat(item) {
      const { gameformats } = this.$store.getters
      const res = getGameformat({ item, gameformats })
      return res
    },
  },
  computed: {
    allTags() {
      return this.$store.getters.tags_get_all_tags('saved_spots')
    },
    thead() {
      const cols = {
        format: {
          name: this.$t('table_head.format'),
          width: 22,
        },
        board: {
          name: this.$t('table_head.board'),
          width: 6,
        },
        actions: {
          name: this.$t('table_head.actions'),
          width: 22,
        },
        note: {
          name: this.$t('table_head.note'),
          width: 22,
        },
        tags: {
          name: this.$t('table_head.tags'),
          width: 14,
        },
        table_actions: {},
      }
      // let res = {}
      // Object.keys(cols).forEach(key => {
      //   let col = cols[key]
      //   let width = col.width
      //   res[key] = {
      //     ...col,
      //     cssStyle: !width ? '' : `
      //       --min-width-th: ${width}rem;
      //       --max-width-th: ${width}rem;
      //       `,
      //     tdStyle: !width ? '' : `
      //       --min-width-td: ${width}rem;
      //       --max-width-td: ${width}rem;
      //       `,
      //   }
      // })
      const colsOrder =
        this.$store.getters.tablesColumns.savedspots || defaultTablesColumns().savedspots
      const res = {}
      Object.keys(cols).forEach(key => {
        if (colsOrder.includes(key)) {
          const col = cols[key]
          const colOrder = colsOrder.indexOf(key) + 1
          const width = col.width || 4
          res[key] = {
            ...col,
            cssStyle: `
            --min-width-th: ${width}rem;
            --max-width-th: ${width}rem;
            order: ${colOrder};`,
            tdStyle: `
            --min-width-td: ${width}rem;
            --max-width-td: ${width}rem;
            order: ${colOrder}`,
          }
        }
      })
      // console.log(res)
      return res
    },
    tcrud_apiData() {
      return this.$store.getters.api_get_data(this.tcrud_mutation)
    },
    tcrud_itemsDrag() {
      const res = this.tcrud_apiData?.results || []
      const { sortKey, sortOrder } = this.tbl_sortConf
      if (sortOrder === 'desc') {
        res.sort((a, b) => (a[sortKey] > b[sortKey] ? -1 : 1))
      } else {
        res.sort((a, b) => (a[sortKey] < b[sortKey] ? -1 : 1))
      }
      return res
    },

    tcrud_items() {
      let res = this.tcrud_apiData?.results || []
      // res = res.filter(i => i.filter_type === this.tableFilterId)

      res = getTagFilteredTableData({
        items: res,
        allTags: this.allTags,
        tagIds: this.filter.filter?.tags || [],
        anyall: this.filter.filter?.tags_anyall,
      })

      const { sortKey, sortOrder } = this.tbl_sortConf

      if (sortOrder === 'desc') {
        res.sort((a, b) => (a[sortKey] > b[sortKey] ? -1 : 1))
      } else {
        res.sort((a, b) => (a[sortKey] < b[sortKey] ? -1 : 1))
      }
      // res = [...res, ...res, ...res]
      // res = [...res, ...res, ...res]
      // res = [...res, ...res, ...res]
      // res = res.map((i, idx) => ({ ...i, public_id: idx }))
      return res
    },
    tcrud_hasNext() {
      return !!this.tcrud_apiData?.links?.next || !!this.tcrud_apiData?.next
    },
    tcrud_apiCall() {
      return this.$store.getters.api_get(this.tcrud_mutation)
    },
    tcrud_loading() {
      return this.tcrud_apiCall?.loading
    },
    tcrud_error() {
      return this.tcrud_apiCall?.error
    },
    filter() {
      return this.$store.getters.ffss
    },
    tcrud_params() {
      return {
        limit: this.tcrud_limit,
        offset: this.tcrud_offset,
      }
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    globals_action() {
      return this.$store.getters.globals_action
    },
  },
  watch: {
    globals_action(a) {
      if (a === 'SavedSpotsTable') {
        this.tcrud_getData()
        this.$store.dispatch('globals_action', '')
      }
    },
  },
}
</script>
